import { Box, Image } from '@chakra-ui/react';
import myDesignsBgImg from 'assets/images/my_designs_bg.jpg';
import { ChameleonProvider } from 'libs/third-party/Chameleon';
import { store } from 'modules/Editor/store';
import { useCallback } from 'react';
import { Provider } from 'react-redux';

import { CardGeneratorModal } from './CardGeneratorModal';

export const CardGenerator = () => {
  // On close, redirect back to My Designs page
  const redirectToMyDesigns = useCallback(() => (window.location.href = '/infographics'), []);

  return (
    <ChameleonProvider>
      <Provider store={store}>
        <Box w='100vw' h='100vh'>
          <Image src={myDesignsBgImg} w='full' h='full' objectFit='cover' objectPosition='top left' />
          <CardGeneratorModal isOpen={true} onClose={redirectToMyDesigns} />
        </Box>
      </Provider>
    </ChameleonProvider>
  );
};
